import { Optional } from '@angular/core';
import { Action } from '@ngrx/store';

export enum AppActionTypes {
  OpenSidenav = '[Application] Open Sidenav',
  CloseSidenav = '[Application] Close Sidenav',
  CheckNetworkConnection = '[Application] Check Network Connection',
  UpdateNetworkConnectionStatus = '[Application] Update Network Connection Status',
  UpdateSplashScreenStatus = '[Application] Update Splash Screen Status',
  UpdateToast = '[Application] Update Toast Message',
  UpdateError = '[Application] Update Error Message',
  UpdateNavSplashScreenStatus = '[Application] Update Navigation Splash Screen Status'
}

export class OpenSidenav implements Action {
  readonly type = AppActionTypes.OpenSidenav;
}

export class CloseSidenav implements Action {
  readonly type = AppActionTypes.CloseSidenav;
}

export class CheckNetworkConnection implements Action {
  readonly type = AppActionTypes.CheckNetworkConnection;
}

export class UpdateNetworkConnectionStatus implements Action {
  readonly type = AppActionTypes.UpdateNetworkConnectionStatus;
  constructor(public payload: boolean) { }
}

export class UpdateSplashScreenStatus implements Action {
  readonly type = AppActionTypes.UpdateSplashScreenStatus;
  constructor(public isLoading: boolean, @Optional() public message: string = "Loading ...") { }
}

export class UpdateToast implements Action {
  readonly type = AppActionTypes.UpdateToast;
  constructor(public toastType: string, public message: string) { }
}

export class UpdateError implements Action {
  readonly type = AppActionTypes.UpdateError;
  constructor(public hasError: boolean, public message: string) { }
}

export class UpdateNavSplashScreenStatus implements Action {
  readonly type = AppActionTypes.UpdateNavSplashScreenStatus;
  constructor(public payload: boolean) { }
}


export type AppActions =
  OpenSidenav
  | CloseSidenav
  | CheckNetworkConnection
  | UpdateNetworkConnectionStatus
  | UpdateSplashScreenStatus
  | UpdateNavSplashScreenStatus;